import React, { useState, useRef } from 'react';
import burger from '../../assets/icons/description_buger.svg';
import Arrow from '../../assets/icons/arrow.svg';
import {
	BoxDetailModalOpen,
	PFPUnboxingData,
} from '../../recoil-states/user-state/user-state';
import { useRecoilState } from 'recoil';
export default function DescriptionInner({ textData, onClick, DumanData }) {
	const [dropDown, setDropDown] = useState(true);
	const [unboxingData, setUnboxingData] = useRecoilState(PFPUnboxingData);
	const [boxDetailModalOpen, setBoxDetailModalOpen] =
		useRecoilState(BoxDetailModalOpen);
	const descriptioninnerContents = textData.story.carousel_duman.slice(1, 6);
	const DropdownRef = useRef(null);
	/**
	 * dropdown 버튼 상태 관리 함수 (열고 닫음)
	 * @author ydw <teammapa.ydw@gmail.com>
	 * @function _toggleDropDown
	 */
	function _toggleDropDown() {
		setDropDown(!dropDown);
	}
	function _DescriptionContents() {
		return (
			<>
				{descriptioninnerContents.map((item, index) => {
					return (
						<div
							key={index}
							className='description-details-contents'
						>
							<div className='description-details-contents-top'>
								<div className='description-details-img-box'>
									<img
										src={require(`../../assets/${item.img}`)}
										alt='description image'
									/>
								</div>
								<div className='description-details-text-box'>
									<h3>
										{item.title} {item.subTitle}
									</h3>
									<p>{item.content}</p>
								</div>
							</div>
							<div className='description-details-contens-btm'>
								<p>
									{textData.story.Breed}: {item.profile.type}
								</p>
								<p>
									{textData.story.Occupation}:{' '}
									{item.profile.job}
								</p>
								<p>
									{textData.story.Style}: {item.profile.style}
								</p>
								<p>
									{textData.story.Characteristics}:{' '}
									{item.profile.pesonality}
								</p>
							</div>
						</div>
					);
				})}
			</>
		);
	}
	return (
		<>
			<div className='description-box'>
				<div className='description-header'>
					<div className='description-header-left'>
						<img src={burger} alt='header buger icon' />
						<p>Description</p>
					</div>
					<div
						className='description-header-right'
						onClick={() => {
							_toggleDropDown();
						}}
					>
						<img
							src={Arrow}
							alt='description dropdown button'
							className={
								dropDown
									? 'description-header-right-arrow active'
									: 'description-header-right-arrow'
							}
						/>
					</div>
				</div>
				<div
					className={'description-details'}
					ref={DropdownRef}
					aria-expanded={!dropDown}
				>
					<div className='description-details-header'>
						<p>1st Konnect NFT</p>
						<p>DUMAN PFP Package</p>
						<p>Package information</p>
					</div>
					<div className='description-details-inner'>
						{_DescriptionContents()}
					</div>
				</div>
			</div>
			<div className='description-details-button'>
				<button
					onClick={() => {
						onClick(unboxingData);
						setBoxDetailModalOpen(false);
					}}
				>
					{textData.modal['get PFP']}
				</button>
			</div>
		</>
	);
}
